// @flow

import { getLang } from '../../i18n/l10n';
import { SET_LANGUAGE, SET_LANGUAGE_DONE } from '../actions';
import type { I18nState, I18nActions } from '../types';

export const initialState: I18nState = {
  language: getLang(),
};

export const i18nReducer = (state: I18nState = initialState, action: I18nActions): I18nState => {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
      };

    case SET_LANGUAGE_DONE:
      return {
        ...state,
        language: action.payload,
      };

    default:
      return state;
  }
};
